import { makeCustomIcon } from './utils';

export const featuredBannerIcon = makeCustomIcon(
  'FeaturedBanner',
  24,
  28,
  'm0 0h24v27.889l-12-3.874-12 3.442z',
);
